'use strict';
'use es6';

var _FormValidator = require('./validation/FormValidator');

var _FormValidator2 = _interopRequireDefault(_FormValidator);

var _FormElement = require('./validation/FormElement');

var _Ajax = require('./utils/Ajax');

var _Ajax2 = _interopRequireDefault(_Ajax);

var _urls = require('./constants/urls');

var _urls2 = _interopRequireDefault(_urls);

var _selectors = require('./constants/selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
  var loginForm = document.querySelector(_selectors.LOGIN.FORM);
  var submitButton = document.querySelector(_selectors.LOGIN.SUBMIT_BUTTON, loginForm);

  var formValidator = new _FormValidator2.default({
    form: loginForm,
    fields: {
      email: {
        selector: _selectors.LOGIN.EMAIL_INPUT,
        validationRule: _FormElement.requiredValidation
      },
      password: {
        selector: _selectors.LOGIN.PASSWORD_INPUT,
        validationRule: _FormElement.requiredValidation
      }
    },
    onSubmit: function onSubmit(_ref, _submitSuccessCallback, submitErrorCallback) {
      var email = _ref.email,
          password = _ref.password;

      submitButton.disabled = true;

      _Ajax2.default.post(_urls2.default.LOGIN_URL, {
        data: { email: email.getValue(), password: password.getValue() },
        callback: function callback() {
          submitButton.disabled = false;
          loginForm.submit();
        },
        errorCallback: function errorCallback(result) {
          submitButton.disabled = false;
          submitErrorCallback(result);
        }
      });
    }
  });

  formValidator.init();
}, false);


//////////////////
// WEBPACK FOOTER
// ./js/login_asset.js
// module id = 9
// module chunks = 2